







import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WNav extends BaseComponent {
	navIcon = require("../assets/images/icon_sx.png");
}
